<!-- Charge Card On file for charge card on file use another component -->
<template>
  <div>
    <section class="mt-25" v-show="!showPaymentDetails">
      <div class="row mt-25">
        <div class="col s6">
          <label>Amount</label>
          <input v-model="amount"
            @input="updateAmounts"
            name="amount"
            class="inputText"
            type="number"
            pattern="\d*"/>
          <input v-model="inputPhone" name="phone" v-if="smsFlow" placeholder="Phone (required)"/>
          <input v-model="note" name="note" placeholder="Note (Name, address, etc)"/>
          <input v-model="invoice" name="invoice" :placeholder="invoiceLabel"/>
        </div>
      </div>

      <div class="row" v-if="smsFlow">
        <div v-show="showTips">
          <div class="col s12 m6">
            <span class="grey-text">Allow tipping for this transaction</span>
            <div class="switch">
              <label>
                Off
                <input type="checkbox" v-model="perTransactionTips">
                <span class="lever"></span>
                On
              </label>
            </div>
          </div>
        </div>
        <div v-show="showVotes">
          <div class="col s12 m6">
            <span class="grey-text">Allow Votes/Feedback</span>
            <div class="switch">
              <label>
                Off
                <input type="checkbox" v-model="showFeedbackHub">
                <span class="lever"></span>
                On
              </label>
            </div>
          </div>
        </div>
      </div>

      <button :disabled="!amount || processing" name="repeatSale" class="mt-25 waves-effect waves-green btn-large wide-btn" @click="submitHandler">
        <span v-if="processing">
          <i class="fas fa-spinner fa-spin grey-text"></i> 
          Processing...
        </span>
        <span v-else>
          {{submitLabel}}<span v-show='amount'> for {{grossAmount | currency}}</span>
        </span>
      </button>
      <div v-show="feeAmount > 0" class="grey-text mt-10">
        <center>Non cash adjustment: {{feeAmount | currency}}</center>
      </div>
    </section>

    <payment-details v-show="showPaymentDetails" :amount="transactionAmount" :id="transactionId"></payment-details>
  </div>
</template>
<script>
  import gql from 'graphql-tag'
  import paymentDetails from './manual_charge/payment_details'

  export default {
    props: {qid: String, gid: String, paymentFlowType: String, card: String, phone: String, requireInvoiceField: Boolean, showVotes: Boolean, showTips: Boolean},
    components: {paymentDetails},
    data() {
      return {
        grossAmount: 0,
        feeAmount: 0,
        withTipAmount: 0,
        amount: null,
        note: null,
        invoice: null,
        processing: false,
        showPaymentDetails: false,
        transactionId: null,
        transactionAmount: null,
        inputPhone: this.phone,
        lastGrossCalcRequestId: 0,
        perTransactionTips: this.showTips,
        showFeedbackHub: this.showVotes
      }
    },
    methods: {
      updateAmounts() {
        // For the frequent updates, we want to make sure we only use the latest request
        // because the requests are async and can come back in any order
        this.lastGrossCalcRequestId++;
        const currentRequestId = this.lastGrossCalcRequestId;

        this.$http.get("/api/v1/vue/gross_calculations", {params: this.paramsGrossCalc}).then(response => {
          if (currentRequestId === this.lastGrossCalcRequestId) {
            this.grossAmount = response.body.gross_amount
            this.feeAmount = response.body.fee
            this.withTipAmount = response.body.amount_with_tip
          }
        })
      },
      submit() {
        this.processing = true
        this.$apollo.mutate({
          mutation: gql`mutation ($id: ID!, $amount: Float!, $tipAmount: Float, $tipPercent: Int, $note: String, $invoice: String) {
            chargeGenericCard(input: {amount: $amount, genericCardId: $id, tipPercent: $tipPercent, tipAmount: $tipAmount, note: $note, invoice: $invoice}) {
              transaction { deprecatedId }
              errors
            }
          }`,
          // Parameters
          variables: {
            amount: Number(this.amount),
            id: this.gid,
            note: this.note,
            invoice: this.invoice,
            tipAmount: this.tipAmount,
            tipPercent: this.selectedTip
          }
        }).then((response) => {
          if(response.data.chargeGenericCard.errors.length > 0) {
            this.processing = false
            this.notifyError(response.data.chargeGenericCard.errors[0])
          } else {
            Turbolinks.visit("/client/ach_transactions/" + response.data.chargeGenericCard.transaction.deprecatedId)
          }
        }).catch((error) => {
          this.processing = false
          this.notifyError(error)
        })
      },
      submitSms() {
        this.processing = true
        this.$apollo.mutate({
          mutation: gql`mutation ($id: ID!, $amount: Float!, $phone: String!, $note: String, $invoice: String, $perTransactionTips: Boolean, $showFeedbackHub: Boolean) {
            chargeGenericCardWithApprove(input: {amount: $amount, genericCardId: $id, phone: $phone, note: $note, invoice: $invoice, perTransactionTips: $perTransactionTips, showFeedbackHub: $showFeedbackHub}) {
              transaction { deprecatedId amount }
              errors
            }
          }`,
          // Parameters
          variables: {
            amount: Number(this.amount),
            id: this.gid,
            note: this.note,
            invoice: this.invoice,
            phone: this.inputPhone,
            perTransactionTips: this.perTransactionTips,
            showFeedbackHub: this.showFeedbackHub
          }
        }).then((response) => {
          if(response.data.chargeGenericCardWithApprove.errors.length > 0) {
            this.processing = false
            this.notifyError(response.data.chargeGenericCardWithApprove.errors[0])
          } else {
            this.transactionId = response.data.chargeGenericCardWithApprove.transaction.deprecatedId
            this.transactionAmount = response.data.chargeGenericCardWithApprove.transaction.amount
            this.showPaymentDetails = true
          }
        }).catch((error) => {
          this.processing = false
          this.notifyError(error)
        })
      }
    },
    computed: {
      smsFlow() {
        return this.paymentFlowType == "manual_sms"
      },
      paramsGrossCalc() {
        return {
          amount: this.amount,
          qid: this.qid
        }
      },
      submitHandler() {
        if(this.smsFlow) {
          return this.submitSms
        } else {
          return this.submit
        }
      },
      submitLabel() {
        if(this.smsFlow) {
          return "Request e-sign"
        } else {
          return "Charge"
        }
      },
      invoiceLabel() {
        return this.requireInvoiceField ? "Invoice # (required)" : "Invoice # (optional)" 
      }
    }
  }
</script>
<style>
</style>
